module.exports = __webpack_public_path__ + "main-banner.jpg?b3167b0e92a5217fd349c67c8d54658b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main-banner.jpg
// module id = 26
// module chunks = 0